import { FC, useEffect } from "react";

import { useStorage } from "../utils/useStorage";
import { useCache } from "../utils/useCache";
import { updatePrimaryThemeColor } from "../utils/ui";
import { PRIMARY_THEME_COLOR, SECONDARY_THEME_COLOR } from "../configs/theme";
import { RouteKey } from "../configs/routes";
import { Layout } from "../components/Layout";
import { WavesBackground } from "../components/WavesBackground";
import { HomeProgress } from "../components/HomeProgress";
import { HomeButtons } from "../components/HomeButtons";
import { HomeTopBar } from "../components/HomeTopBar";

export const Home: FC = () => {
  const { todayProgress } = useStorage();
  const { isScreenFilled, setScreenFilled } = useCache();

  const handleScreenFilledChange = (value: boolean) => setScreenFilled && setScreenFilled(value);

  useEffect(() => {
    updatePrimaryThemeColor(isScreenFilled ? SECONDARY_THEME_COLOR : PRIMARY_THEME_COLOR);
  }, [isScreenFilled]);

  const handleAnimationEnd = () => todayProgress >= 1 && handleScreenFilledChange(true);
  const handleAnimationStart = () => todayProgress < 1 && handleScreenFilledChange(false);

  return (
    <WavesBackground
      progress={todayProgress}
      onAnimationEnd={handleAnimationEnd}
      onAnimationStart={handleAnimationStart}
    >
      <Layout route={RouteKey.INDEX}>
        <HomeTopBar />
        <HomeProgress />
        <HomeButtons />
      </Layout>
    </WavesBackground>
  )
}